import { render, staticRenderFns } from "./ModifyThirdPersonAssurance.vue?vue&type=template&id=034496c8"
import script from "./ModifyThirdPersonAssurance.vue?vue&type=script&lang=js"
export * from "./ModifyThirdPersonAssurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports